import { h } from 'preact';

import Dashboard from './components/dashboard';
import { ON_RPM, ON_RUNNER } from './consts.js';
import globalErrorHandler from './utils/errorHandler.js';
import { loadAllProperties } from './utils/propertyUtils.js';
import { preloadAccountData as preloadRebelmouseAccountData } from './utils/rmUtils.js';
import { preloadAccountData as preloadRPMAccountData } from './utils/rpmUtils.js';

function bootProperties() {
  loadAllProperties().catch(globalErrorHandler);
}

function rebelMousePrewarm() {
  preloadRebelmouseAccountData().catch(globalErrorHandler);
}

function rpmPrewarm() {
  preloadRPMAccountData().catch(globalErrorHandler);
}

function App() {
  bootProperties();
  if (ON_RUNNER) {
    rebelMousePrewarm();
  }

  if (ON_RPM) {
    rpmPrewarm();
  }
  return h(Dashboard);
}

export default App;
